import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=3b98872e&scoped=true&"
import script from "./PayDialog.vue?vue&type=script&lang=js&"
export * from "./PayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98872e",
  null
  
)

export default component.exports